module.exports = __webpack_public_path__ + "img/bakerbookhouse.480a2c9f.png";